import { render, staticRenderFns } from "./Rubro.vue?vue&type=template&id=402be641&"
import script from "./Rubro.vue?vue&type=script&lang=js&"
export * from "./Rubro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports